import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.92 3.17',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Layer_2" data-name="Layer 2">
      <path
        fill={fill}
        d="M3.66,3.17H.26A.27.27,0,0,1,0,2.9V1A.27.27,0,0,1,.26.68h3.4A.27.27,0,0,1,3.92,1v2A.27.27,0,0,1,3.66,3.17ZM.26.8A.15.15,0,0,0,.12,1v2a.15.15,0,0,0,.14.15h3.4A.15.15,0,0,0,3.8,2.9V1A.15.15,0,0,0,3.66.8Z"
      />
      <path
        fill={fill}
        d="M2.64.8A.06.06,0,0,1,2.58.74V.45A.33.33,0,0,0,2.25.12H1.67a.33.33,0,0,0-.33.33V.74a.06.06,0,0,1-.12,0V.45A.45.45,0,0,1,1.67,0h.58A.45.45,0,0,1,2.7.45V.74A.06.06,0,0,1,2.64.8Z"
      />
      <path
        fill={fill}
        d="M3.24,3.17a.06.06,0,0,1-.06-.06V.74a.06.06,0,1,1,.12,0V3.11A.06.06,0,0,1,3.24,3.17Z"
      />
      <path
        fill={fill}
        d="M3.5,3.17a.06.06,0,0,1-.06-.06V.74A.06.06,0,0,1,3.5.68a.06.06,0,0,1,.06.06V3.11A.06.06,0,0,1,3.5,3.17Z"
      />
      <path
        fill={fill}
        d="M.43,3.17a.06.06,0,0,1-.06-.06V.74A.06.06,0,0,1,.43.68.06.06,0,0,1,.49.74V3.11A.06.06,0,0,1,.43,3.17Z"
      />
      <path
        fill={fill}
        d="M.68,3.17a.06.06,0,0,1-.06-.06V.74A.06.06,0,0,1,.68.68.06.06,0,0,1,.74.74V3.11A.06.06,0,0,1,.68,3.17Z"
      />
      <path
        fill={fill}
        d="M1.87,1.54H1.2a.06.06,0,0,1-.06-.06V1.13a.06.06,0,0,1,.06-.06h.67a.06.06,0,0,1,.06.06v.35A.06.06,0,0,1,1.87,1.54Zm-.61-.12h.55V1.19H1.26Z"
      />
      <path
        fill={fill}
        d="M2.79,2.46H2.38a.06.06,0,0,1-.06-.06V1.77a.07.07,0,0,1,.06-.07h.41s.06,0,.06.07V2.4A.06.06,0,0,1,2.79,2.46Zm-.35-.13h.29v-.5H2.44Z"
      />
      <path
        fill={fill}
        d="M1.54,2.83H1.2a.06.06,0,0,1-.06-.06V1.88a.06.06,0,0,1,.06-.06h.34a.06.06,0,0,1,.06.06v.89A.06.06,0,0,1,1.54,2.83Zm-.28-.12h.21V1.94H1.26Z"
      />
    </g>
  </svg>
);

export default SVG;
